module.exports = __webpack_public_path__ + "static/airport-video-6059bb5b916d7cf700726e0875575ebb.mp4";